import change_profile from './change_profile'
import change_password from './change_password';

export default {
  title: 'Settings',
  language: {
    title: 'Language',
  },
  change_profile,
  change_password,
}
